import { defineRecipe } from '@plurall/elo-v3';

export const dashboardEmptyStateRecipe = defineRecipe({
  className: 'dashboard-empty-state',
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'gap.xsmall',
    padding: 'padding.4xlarge',
    minHeight: '200px',
    textAlign: 'center',
  },
});
